<template>
  <el-tag
      :style="{'color': color}"
      style="border: none;"
      :color="bgColor"
      v-on="$listeners"
      v-bind="$attrs">
    <slot></slot>
  </el-tag>
</template>

<script>
const thems = {
  "primary": {
    color: "#ffffff",
    bgColor: "#bd3124",
  },
  "default": {
    color: "#333333",
    bgColor: "#efefef",
  }
}
export default {
  name: "AnTag",
  props: {
    type: {
      type: String,
      default: "default"
    }
  },
  computed: {
    color() {
      return thems[this.type].color
    },
    bgColor() {
      return thems[this.type].bgColor
    }
  }
}
</script>

<style scoped>

</style>